import React, { ReactNode } from 'react';
import { AccountType } from 'eve-account-client';
import EVerifyUser from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUser';
import EVerifyUsersFormMFA from '../../../../components/Enrollment/EVerifyUsers/EVerifyUsersFormMFA';
import { useEnrollment } from '../../../../context/Enrollment/EnrollmentContext';
import { EnrollmentData } from '../../EnrollmentData';

export type BaseEVerifyUsersMFAProps = {
  pageTitle?: string;
  primaryText: ReactNode;
};

const BaseEVerifyUsersMFA = ({ pageTitle = 'E-Verify Users', primaryText }: BaseEVerifyUsersMFAProps): JSX.Element => {
  const { enrollmentData, nextPage, setEnrollmentData } = useEnrollment();
  const isCorporateAdmin = enrollmentData.accessMethodFormData?.type === AccountType.CORPORATE;

  const onSubmit = (adminUser: EVerifyUser, mouSignatory: EVerifyUser, mouSignatoryIsSame: boolean) => {
    const updatedUsers = isCorporateAdmin
      ? [{ ...adminUser, admin: 'Yes', mouSignatory: 'No' }]
      : [
          { ...adminUser, admin: 'Yes', mouSignatory: 'No' },
          { ...mouSignatory, admin: 'No', mouSignatory: 'Yes' },
        ];

    setEnrollmentData((prevState: EnrollmentData) => {
      return {
        ...prevState,
        everifyUserFormData: updatedUsers,
        mouSignatoryIsSame,
      };
    });
  };

  return (
    <section className="padding-y-4">
      <h1 className="margin-bottom-4">{pageTitle}</h1>
      {primaryText}
      <EVerifyUsersFormMFA
        isCorporateAdmin={isCorporateAdmin}
        usersData={enrollmentData.everifyUserFormData || []}
        signatoryIsSame={enrollmentData?.mouSignatoryIsSame || false}
        onNext={nextPage}
        onSubmit={onSubmit}
      />
    </section>
  );
};

export default BaseEVerifyUsersMFA;
